import { ElementObserver } from 'viewprt'
import { mediaBreakpoints } from '../utils'
import { getElements } from '../utils/functional'

export default class FadeIn {
  constructor () {
    this.els = getElements('.js-FadeIn')
    this.activeClass = 'fde-Fadein-active'

    if (window.innerWidth > mediaBreakpoints.sm) {
      this.els.forEach(el =>
        ElementObserver(el, {
          offset: -100,
          onEnter: () => {
            el.classList.add(this.activeClass)
          }
        })
      )
    } else {
      this.els.forEach(el => el.classList.add(this.activeClass))
    }
  }
}
